import React from 'react';
import close from "../../../../images/close.svg";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {sendConfirmEmail} from "../../../../redux/user/user-thunks";
import {setIsConfirmError} from "../../../../redux/auth/auth-actions";

const ConfirmEmailError = ({isDark, setIsConfirmError, sendConfirmEmail}) => {
  const {t} = useTranslation()
  return (
    <div style={{width: 541}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={() => setIsConfirmError(false)} className="modal__close">
        <img src={close} alt=""/>
      </button>
      {/*<h5 className="modal__title mr-30">Добавьте e-mail</h5>*/}
      {/*<p className="modal__text">Чтобы пользоваться функционалом Логбука, пожалуйста, добавтьте свой e-mail </p>*/}
      <p className="modal__text">{t('expiredLabelFirst')}</p>
      <p className="modal__text">{t('expiredLabelSecond')}</p>
      <div className="modal__buttons mt-12">
        <button onClick={() => {
          sendConfirmEmail()
          setIsConfirmError(false)
        }} className="submit-button">
          {t('confirmSend')}
        </button>
        <button onClick={() => setIsConfirmError(false)} className="commonBtn">
          <span className="commonBtn__label">{t('cancel')}</span>
        </button>
      </div>
    </div>
  );
};

export default connect(null, {sendConfirmEmail, setIsConfirmError})(ConfirmEmailError)
